import { useGetSaleReports } from 'api-hooks/report';
import useDefaultValuesReportDate from 'hooks/use-default-values-report-date';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import PivotReportTemplate from './components/pivot-report-template';

export default function SaleReport() {
  const { t } = useTranslation();
  const defaultFilters = useDefaultValuesReportDate('transaction');
  return (
    <PivotReportTemplate
      title={t('common:sales_report')}
      usePivotQuery={useGetSaleReports}
      completeName={['customer', 'operator', 'sales', 'lead', 'type']}
      defaultFilters={defaultFilters}
    />
  );
}
